import { constructAddressObjToString } from '@libraries/helpers';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  eligibleFundsFeatureKey,
  EligibleFundsState,
} from './eligible-funds.reducer';

export const selectEligibleFundsState =
  createFeatureSelector<EligibleFundsState>(eligibleFundsFeatureKey);

export const getOwnerData = createSelector(
  selectEligibleFundsState,
  (state: EligibleFundsState) => state.ownerData
);

export const isLoading = createSelector(
  selectEligibleFundsState,
  (state: EligibleFundsState) => state.loading
);

export const getAddressChoices = createSelector(
  selectEligibleFundsState,
  (state: EligibleFundsState) =>
    state.addressChoices?.map((choice) => ({
      ...choice,
      display: constructAddressObjToString(choice),
    }))
);

export const getUser = createSelector(
  selectEligibleFundsState,
  (state: EligibleFundsState) => ({
    email: state.email,
  })
);

export const getMetadata = createSelector(
  selectEligibleFundsState,
  (state) => ({
    how_soon: state.urgency,
    improvements: state.improvementList,
  })
);

export const getAddressSelectPayload = createSelector(
  getUser,
  getMetadata,
  (user, metadata) => ({
    metadata,
    user,
  })
);
